import type {
  ToastProps,
  ToastType,
} from "~/types/schemas/common/Atom/toaster";
export const useToast = () => {
  const toasts = useState<ToastProps[]>("toasts");

  const addToast = (message: string, type?: ToastType, duration?: number) => {
    const toastOption: ToastProps = {
      id: Math.ceil(Math.random() * 100000),
      position: "top-right",
      duration: duration ?? 3000,
      type,
      message,
    };

    toasts.value = [...(toasts.value ?? []), toastOption];
  };

  const removeToast = (id: number) => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  return { toasts, addToast, removeToast };
};
